import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import { mapActions, mapGetters, mapState } from "vuex";
import { UPDATE_STATE_COLUMN_LABEL } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARDS, SELECTED_BOARD, PROFILES, STATUSES } from "@Broker/@Modules/clients/board/store/board-getters";
import ClientBoardStatesBar from "./states-bar/client-board-states-bar";
import ClientProfilesTable from "./client-profiles-table";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientBoardClassicContainer",
  components: {
    Fragment,
    ClientBoardStatesBar,
    ClientProfilesTable
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [STATUSES, PROFILES, SELECTED_BOARD, BOARDS])), mapState("BoardStore", ["boardsStatusesTranslationMap"])), {}, {
    statusNameList() {
      var _context;
      if (!this.STATUSES.byId) return [];
      return _mapInstanceProperty(_context = _Object$values(this.STATUSES.byId)).call(_context, ({
        label
      }) => {
        var _this$$options$filter;
        return (_this$$options$filter = this.$options.filters.getSchemaTranslation(label, this.boardsStatusesTranslationMap[this.selectedBoardId])) != null ? _this$$options$filter : label;
      });
    },
    selectedBoardId() {
      return this.SELECTED_BOARD.id;
    },
    orderedStatuses() {
      var _context2;
      if (!this.SELECTED_BOARD || !this.STATUSES.byId) return [];
      return _mapInstanceProperty(_context2 = this.SELECTED_BOARD.order).call(_context2, order => this.STATUSES.byId[order]);
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [UPDATE_STATE_COLUMN_LABEL])), {}, {
    handleStatusEdit({
      label,
      id
    }) {
      this.UPDATE_STATE_COLUMN_LABEL({
        statusLabelId: id,
        label
      });
    }
  })
});